import { render, staticRenderFns } from "./BackupCreate.vue?vue&type=template&id=2b5f4226&"
import script from "./BackupCreate.vue?vue&type=script&lang=js&"
export * from "./BackupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports